var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "spam") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(-537.000000, -8.000000)",
    fill: "#7450C8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(500.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "spam",
    transform: "translate(38.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4508125,2.96554688 L9.03447656,0.5491875 C8.68033594,0.195046875 8.20947656,0 7.70864062,0 L4.29138281,0 C3.79052344,0 3.3196875,0.195046875 2.96554687,0.5491875 L0.5491875,2.96554688 C0.195046875,3.3196875 0,3.79054687 0,4.29138281 L0,7.70861719 C0,8.20947656 0.195046875,8.6803125 0.5491875,9.03445312 L2.96554688,11.4508125 C3.3196875,11.8049531 3.79054688,12 4.29138281,12 L7.70861719,12 C8.20947656,12 8.6803125,11.8049531 9.03447656,11.4508359 L9.785625,10.6996875 C9.96869531,10.5166406 9.96867187,10.2198516 9.785625,10.0367813 C9.60257812,9.85371094 9.30578906,9.85371094 9.12271875,10.0367813 L8.37157031,10.7879297 C8.19447656,10.965 7.95907031,11.0625234 7.70864062,11.0625234 L4.29138281,11.0625234 C4.04095312,11.0625234 3.80552344,10.965 3.62845313,10.7879297 L1.21209375,8.37157031 C1.03502344,8.19447656 0.9375,7.95907031 0.9375,7.70864062 L0.9375,4.29138281 C0.9375,4.04095312 1.03502344,3.80552344 1.21209375,3.62845313 L3.62845313,1.21209375 C3.80554688,1.03502344 4.04095312,0.9375 4.29138281,0.9375 L7.70861719,0.9375 C7.95904687,0.9375 8.19447656,1.03502344 8.37154687,1.21209375 L10.7879062,3.62845313 C10.9649766,3.80554688 11.0625,4.04095312 11.0625,4.29138281 L11.0625,7.70864062 C11.0625,7.95907031 10.9649766,8.1945 10.7879062,8.37157031 C10.6048359,8.55461719 10.6048594,8.85140625 10.7879062,9.03447656 C10.9709531,9.21754688 11.2677422,9.21754688 11.4508125,9.03447656 C11.8049531,8.68033594 12,8.20947656 12,7.70864062 L12,4.29138281 C12,3.79054687 11.8049531,3.3196875 11.4508125,2.96554688 Z",
    id: "Path",
    stroke: "#7450C8",
    strokeWidth: 0.5,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.77777778,3 C5.34822297,3 5,3.34822297 5,3.77777778 L5,5.33333333 C5,5.76288814 5.34822297,6.11111111 5.77777778,6.11111111 C6.20733258,6.11111111 6.55555556,5.76288814 6.55555556,5.33333333 L6.55555556,3.77777778 C6.55555556,3.34822297 6.20733258,3 5.77777778,3 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22556857,7.23010209 C5.08344234,7.37915059 5.00287795,7.57639443 5.00001302,7.78232431 C4.99881776,7.98905996 5.07997906,8.18776522 5.22556857,8.33454653 C5.3011693,8.40324837 5.38798032,8.45849174 5.48223524,8.49787986 C5.67048848,8.58108403 5.88509311,8.58108403 6.07334635,8.49787986 C6.26874766,8.42716135 6.42262784,8.27328117 6.49334635,8.07787986 C6.5368874,7.98557368 6.55819755,7.8843505 6.55556857,7.78232431 C6.55740617,7.46634036 6.36788786,7.18065094 6.07605419,7.05948024 C5.78422052,6.93830953 5.44808337,7.00574435 5.22556857,7.23010209 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.f322de297a94b73cf20a16d1866ef72e.svg";
export { ForwardRef as ReactComponent };